import React from 'react';
import { Spin } from 'antd';
import GcCarcasa from './GcCarcasa';
import { usePermissions } from '../../contexts/PermissionContext';
import '../../estilos/gescomaux.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

/**
 * Carcasa interna de GescomAux (GCVSC-I001): raíl con el menú filtrado por ACL (GcCarcasa) y
 * lienzo tenue. Sin GCvsc.Menu.Read, modo presentación: el contenido sin raíl ni menú.
 */
const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 16 }}>
        <Spin size="large" />
        <p>Cargando permisos...</p>
      </div>
    );
  }

  // Sin raíl ni menú → modo presentación (usuarios sin GCvsc.Menu.Read)
  if (!hasPermission('GCvsc.Menu.Read')) {
    return <main className="gc-presentacion">{children}</main>;
  }

  return <GcCarcasa>{children}</GcCarcasa>;
};

export default MainLayout;
